import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';

import css from './ListMapToggle.module.css';

const IconList = () => (
  <svg className={css.icon} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M8 6h13M8 12h13M8 18h13" fill="none" strokeWidth="2" strokeLinecap="round" />
    <circle cx="3.5" cy="6" r="1.5" />
    <circle cx="3.5" cy="12" r="1.5" />
    <circle cx="3.5" cy="18" r="1.5" />
  </svg>
);

const IconMap = () => (
  <svg className={css.icon} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M9 4L3 6v14l6-2 6 2 6-2V4l-6 2-6-2zM9 4v14M15 6v14"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * The mobile List | Map segmented toggle (map variant): bottom-center fixed, thumb-reachable, always
 * visible above the map modal so switching back is one obvious tap -- replaces the stock tiny "Map"
 * icon buried in the filter bar. Hidden from the medium viewport up (desktop shows list + map side by
 * side).
 *
 * @param {Object} props
 * @param {'list'|'map'} props.active which view is showing
 * @param {Function} props.onSelect called with 'list' or 'map'
 */
const ListMapToggle = ({ active, onSelect }) => (
  // Toggle buttons (aria-pressed), NOT tabs: tab semantics require arrow-key navigation and
  // aria-controls wiring; for a two-state view switcher pressed-state buttons are the correct
  // (and simpler) pattern.
  <div className={css.root} role="group">
    <button
      type="button"
      aria-pressed={active === 'list'}
      className={classNames(css.option, { [css.optionActive]: active === 'list' })}
      onClick={() => onSelect('list')}
    >
      <IconList />
      <FormattedMessage id="ListMapToggle.list" />
    </button>
    <button
      type="button"
      aria-pressed={active === 'map'}
      className={classNames(css.option, { [css.optionActive]: active === 'map' })}
      onClick={() => onSelect('map')}
    >
      <IconMap />
      <FormattedMessage id="ListMapToggle.map" />
    </button>
  </div>
);

export default ListMapToggle;
